import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgMoment({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm-2 14.173v3.575A8.015 8.015 0 0012 20c.737 0 1.45-.1 2.128-.286L10 16.173zm-2-3.304l-2.829 3.3A8.04 8.04 0 008 18.93v-6.06zM12.87 16l3.3 2.829A8.04 8.04 0 0018.93 16L12.87 16zm-5.044-6H4.252A8.014 8.014 0 004 12c0 .737.1 1.45.286 2.128l3.54-4.129zm11.888-.128L16.173 14h3.575c.164-.64.252-1.31.252-2.001 0-.737-.1-1.45-.286-2.128zM12 10a2 2 0 100 4 2 2 0 000-4zm4.001-4.93L16 11.13l2.829-3.299A8.04 8.04 0 0016 5.07zm-8.17.1A8.04 8.04 0 005.07 8h6.059l-3.3-2.83zM12 4c-.737 0-1.45.1-2.128.286l4.129 3.54V4.252A8.014 8.014 0 0012 4z"
        fill={color}
      />
    </svg>
  )
}

export default SvgMoment
